<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.racking.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.racking.racksets' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.racking.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.name.label' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.racking.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['racks'].invalid && controls['racks'].touched) {
			<mat-error>{{ 'masterdata.racking.dialog.racks.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.racks.label' | translate }}</mat-label>
			<mat-select formControlName="racks" multiple>
				@for (rack of availableRacks?.items; track rack) {
				<mat-option [value]="rack.self">{{ rack.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.racking.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.racking.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
